import { render, staticRenderFns } from "./WidgetMontanari.vue?vue&type=template&id=14039eb2&"
import script from "./WidgetMontanari.vue?vue&type=script&lang=js&"
export * from "./WidgetMontanari.vue?vue&type=script&lang=js&"
import style0 from "./WidgetMontanari.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WidgetMontanari.vue"
export default component.exports